import { createFileRoute } from "@tanstack/react-router";

import SummaryOfScans from "~/pages/MeqLive/SummaryOfScans";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/meq-live/summary-of-scans")({
  staticData: ROUTE_STATIC.meqLive,
  component: SummaryOfScans,
});
